import React, { ReactElement } from "react";
import { useAuth } from "../utils/auth/assist/authContext";
import NoAccessPage from "./noAccessPage";

interface ProtectedFeaturePageProps {
  featureKey: string;
  productName: string;
  children: ReactElement;
}

const ProtectedFeaturePage: React.FC<ProtectedFeaturePageProps> = ({
  featureKey,
  productName,
  children,
}) => {
  const { user } = useAuth();
  const hasAccess = !!user?.[featureKey];

  if (!hasAccess) {
    return <NoAccessPage product={productName} />;
  }

  return children;
};

export default ProtectedFeaturePage;